import { usePage } from '@inertiajs/vue3'

// Money formatting for ANONYMOUS public pages. useCurrency() reads
// app_setting, which is shared only to signed-in CRM users — on public
// pages it silently falls back to THB formatting while the estimate
// *_cents props are already in the visitor's DISPLAY currency (a real bug
// for .ru visitors, who default to RUB: they'd see ruble-valued numbers
// labeled ฿). Mirrors usePublicDate's approach: key off the server-shared
// public props (PublicLayout::resolve_display_currency / PublicLocale)
// instead of app_setting, with THB/browser-locale fallbacks when a prop
// is missing (e.g. this composable used outside the public layout).
export function usePublicMoney() {
  const page = usePage()
  const loc = () => page.props.locale || []
  const currency = () => page.props.display_currency || 'THB'

  // Same rule as Public::BaseController#fmt_money: whole amounts drop the
  // decimals ("฿25,000"), fractional ones keep them ("$12.50").
  function formatMoney(cents) {
    if (cents == null) return '—'
    const whole = Number.isInteger(cents) && cents % 100 === 0
    return new Intl.NumberFormat(loc(), {
      style: 'currency', currency: currency(),
      ...(whole ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
    }).format(cents / 100)
  }

  return { formatMoney, currency }
}
